const labels = [
  {
    name: 'S.No',
    value: 'index',
  },
  {
    name: 'Name',
    value: 'candidateName',
  },
  {
    name: 'Roll No',
    value: 'universityRollNo',
  },
  {
    name: 'Graduation Marks',
    value: 'marksGraduation',
  },
  {
    name: 'Graduation YOP',
    value: 'yopGraduation',
  },
  {
    name: 'Branch',
    value: 'stream',
  },
  {
    name: 'Degree',
    value: 'degree',
  },
  {
    name: 'Backlogs',
    value: 'backlogs',
  },
  {
    name: 'Placement Status',
    value: 'placementStatus',
  },
  {
    name: '10th Marks',
    value: 'marks10',
  },
  {
    name: 'Year of Passing',
    value: 'yop10',
  },
  {
    name: '12th Marks',
    value: 'marks12',
  },
  {
    name: 'Year of Passing',
    value: 'yop12',
  },
  {
    name: 'DOB',
    value: 'dateOfBirth',
  },
  {
    name: 'Gender',
    value: 'gender',
  },
  {
    name: 'Email',
    value: 'primaryEmail',
  },
  {
    name: 'Contact',
    value: 'primaryContact',
  },
  {
    name: 'Certifications',
    value: 'certifications',
  },
];

const csvConverter = (JSONData, fileName = 'Registrations') => {
  const arrData =
    typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
  let csv = '';
  let row = '';
  labels.forEach((fieldName) => {
    row += `${fieldName.name},`;
  });
  row = row.slice(0, -1);
  csv += `${row}\r\n`;
  for (let i = 0; i < arrData.length; i += 1) {
    row = '';
    const arrRow = arrData[i];
    // eslint-disable-next-line
    labels.forEach(fieldName => {
      const { value } = fieldName;

      if (value === 'index') {
        row += `${i + 1},`;
      } else {
        const arrValue =
          typeof arrRow[value] === 'undefined' ? '' : `"${arrRow[value]}"`;
        row += `${arrValue},`;
      }
    });
    row.slice(0, row.length - 1);
    csv += `${row}\r\n`;
  }

  if (csv === '') {
    return;
  }

  const uri = `data:application/csv;charset=utf-8,${escape(csv)}`;
  const link = document.createElement('a');
  link.href = uri;
  link.style = 'visibility:hidden';
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default csvConverter;



// WEBPACK FOOTER //
// ./src/utils/CandidateCSV.js